module.exports = __webpack_public_path__ + "static/media/04-galeria-01-perisur@2x.afbf4cea.jpg";